import React from "react";

import { useNotify, useQueryWithStore, useDataProvider } from "react-admin";

import { TextField } from "final-form-material-ui";

import { Form, Field } from "react-final-form";
import { useAuthenticated } from "react-admin";

import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";

import { makeStyles } from "@material-ui/styles";

const useStyle = makeStyles({
  button: {
    color: "#fff",
  },
  loader: {
    color: "#fff",
  },
  fieldWidth50: {
    width: 300,
  },
});

const Alert = (props) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const Address = () => {
  useAuthenticated();
  const uid = localStorage.getItem("user");
  const { data } = useQueryWithStore({
    type: "getOne",
    resource: "User",
    payload: { id: uid },
  });

  const classes = useStyle();
  const notify = useNotify();
  const dataProvider = useDataProvider();
  const [loading, setLoading] = React.useState(false);
  const [notification, setNotification] = React.useState({
    open: false,
    type: "info",
    message: "",
  });
  let validatecity = /^[a-zA-Z ]{2,20}$/;
  let validatestate = /^[a-zA-Z ]{2,20}$/;
  let validatecountry = /^[a-zA-Z ]{2,20}$/;

  const OnSubmit = async (values) => {
    setLoading(true);
    let submitflag = true;
    if (!values.addressLine1) {
      notify("Kindly fill your address");
      submitflag = false;
    }
    if (!values.city) {
      notify("City missing from address");
      submitflag = false;
    }
    if (!values.state) {
      notify("State Missing from address");
      submitflag = false;
    }
    if (!values.country) {
      notify("Country missing from address");
      submitflag = false;
    }
    if (!values.pincode) {
      notify("Pincode missing from address");
      submitflag = false;
    }
    values.pincode = parseInt(values.pincode);
    if (submitflag) {
      dataProvider
        .update("User", {
          id: uid,
          data: values,
        })
        .then(
          (success) => {
            setLoading(false);
            setNotification({
              open: true,
              type: "success",
              message: "Address Updated Successfully",
            });
          },
          (error) => {
            setLoading(false);
            setNotification({
              open: true,
              type: "error",
              message: "Something went wrong. Please retry",
            });
          }
        );
    }
  };

  const validate = (values) => {
    let pincode = parseInt(values.pincode);
    const errors = {};
    if (!values.addressLine1) {
      errors.addressLine1 = "Required";
    }
   
    if (!pincode) {
      errors.pincode = "Required";
    } else {
      if (pincode.toString().length !== 6) {
        errors.pincode = "Incorrect pincode";
      }
    }
    if (!values.city) {
      errors.city = "Required";
    }
    if (values.city && !values.city.match(validatecity)) {
      errors.city = "Invalid City";
    }
    if (!values.state) {
      errors.state = "Required";
    }
    if (values.state && !values.state.match(validatestate)) {
      errors.state = "Invalid State";
    }

    if (!values.country) {
      errors.country = "Required";
    }
    if (values.country && !values.country.match(validatecountry)) {
      errors.country = "Invalid Country";
    }

    return errors;
  };

  // remove object as submit does not work with it
  delete data["availability"];

  return (
    <Form
      onSubmit={OnSubmit}
      initialValues={data}
      validate={validate}
      render={({ handleSubmit, reset, submitting, pristine, values }) => (
        <form onSubmit={handleSubmit} noValidate>
          <Grid
            container
            direction="column"
            justify="flex-start"
            alignItems="flex-start"
            spacing={2}
          >
            <Grid item>
              <Field
                xs={12}
                fullWidth
                required
                name="addressLine1"
                component={TextField}
                type="text"
                label="Address Line 1"
                className={classes.fieldWidth50}
              />
            </Grid>
            <Grid item>
              <Field
                xs={12}
                fullWidth
                name="addressLine2"
                component={TextField}
                type="text"
                label="Address Line 2"
                className={classes.fieldWidth50}
              />
            </Grid>
            <Grid item style={{ width: "80vw" }}>
              <Grid
                container
                direction="row"
                alignItems="flex-start"
                spacing={2}
              >
                <Grid item>
                  <Field
                    xs={12}
                    fullWidth
                    required
                    name="city"
                    component={TextField}
                    type="text"
                    label="City"
                  />
                </Grid>
                <Grid item>
                  <Field
                    xs={12}
                    fullWidth
                    required
                    name="state"
                    component={TextField}
                    type="text"
                    label="State"
                  />
                </Grid>
                <Grid item>
                  <Field
                    xs={12}
                    fullWidth
                    required
                    name="country"
                    component={TextField}
                    type="text"
                    label="Country"
                  />
                </Grid>
                <Grid item>
                  <Field
                    xs={12}
                    fullWidth
                    required
                    name="pincode"
                    component={TextField}
                    type="number"
                    label="Pincode"
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item style={{ marginTop: 16 }}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                disabled={loading}
                className={classes.button}
              >
                {!loading ? "Submit" : <CircularProgress />}
              </Button>
            </Grid>
          </Grid>
          <Snackbar open={notification.open} autoHideDuration={800}>
            <Alert severity={notification.type}>{notification.message}</Alert>
          </Snackbar>
        </form>
      )}
    />
  );
};

export default Address;
